import {
  APPROVER_GET_ALL_PROPOSAL_FAIL,
  APPROVER_GET_ALL_PROPOSAL_REQUEST,
  APPROVER_GET_ALL_PROPOSAL_SUCCESS,
  APPROVE_PROPOSAL_FAIL,
  APPROVE_PROPOSAL_REQUEST,
  APPROVE_PROPOSAL_SUCCESS,
  CREATE_PROPOSAL_FAIL,
  CREATE_PROPOSAL_REQUEST,
  CREATE_PROPOSAL_RESET,
  CREATE_PROPOSAL_SUCCESS,
} from "../constants/proposalConstants";

export const proposalCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_PROPOSAL_REQUEST:
      return { loading: true };
    case CREATE_PROPOSAL_SUCCESS:
      return { loading: false, success: true, createdProposal: action.payload };

    case CREATE_PROPOSAL_FAIL:
      return { loading: false, error: action.payload };
    case CREATE_PROPOSAL_RESET:
      return {};
    default:
      return state;
  }
};

export const getAllProposalsApproverReducer = (
  state = { allProposals: [] },
  action
) => {
  switch (action.type) {
    case APPROVER_GET_ALL_PROPOSAL_REQUEST:
      return { loading: true, allProposals: [] };
    case APPROVER_GET_ALL_PROPOSAL_SUCCESS:
      return { loading: false, allProposals: action.payload };
    case APPROVER_GET_ALL_PROPOSAL_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const updateProposalReducer = (state = {}, action) => {
  switch (action.type) {
    case APPROVE_PROPOSAL_REQUEST:
      return { loading: true, success: false };
    case APPROVE_PROPOSAL_SUCCESS:
      return { loading: false, success: true, approvedPost: action.payload };

    case APPROVE_PROPOSAL_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};
